import { Type } from '@angular/core';

import { ContentKind, SlideLayout, SlideTimingKind } from '../runtime/slides/enums';
import { RuntimeSlideModel } from '../runtime/slides/models';
import { BackdropLayoutComponent } from './layouts/backdrop-layout/backdrop-layout.component';
import { FullscreenLayoutComponent } from './layouts/fullscreen-layout/fullscreen-layout.component';
import { SplitLayoutComponent } from './layouts/split-layout/split-layout.component';
import { TableLayoutComponent } from './layouts/table-layout/table-layout.component';
import { VideoLayoutComponent } from './layouts/video-layout/video-layout.component';

export const SLIDE_LAYOUTS: Readonly<Record<SlideLayout, Type<unknown>>> = {
  [SlideLayout.Split]: SplitLayoutComponent,
  [SlideLayout.Backdrop]: BackdropLayoutComponent,
  [SlideLayout.Table]: TableLayoutComponent,
  [SlideLayout.Fullscreen]: FullscreenLayoutComponent,
  [SlideLayout.Video]: VideoLayoutComponent
};

const STATUS_DURATION_MS = 15_000;

const STATUS_SLIDE: Pick<RuntimeSlideModel, 'kind' | 'layout' | 'duration' | 'meta'> = {
  kind: ContentKind.Status,
  layout: SlideLayout.Backdrop,
  duration: { kind: SlideTimingKind.Fixed, milliseconds: STATUS_DURATION_MS },
  meta: { sourceId: -999 }
};

export const FETCHING_SLIDE: RuntimeSlideModel = {
  ...STATUS_SLIDE, id: 'status:fetching',
  content: {
    id: -999, providerChannelIds: [0], images: ['url(assets/images/fetching-empty.jpg)'],
    title: 'LOADING.Title', bodyText: 'LOADING.Description'
  }
};

export const NO_INTERNET_SLIDE: RuntimeSlideModel = {
  ...STATUS_SLIDE, id: 'status:no-internet',
  content: {
    id: -999, providerChannelIds: [0], images: ['url(assets/images/fetching-empty.jpg)'],
    title: 'LOADING.NoInternet', bodyText: 'LOADING.Description'
  }
};

export const NO_CONTENT_SLIDE: RuntimeSlideModel = {
  ...STATUS_SLIDE, id: 'status:no-content',
  content: {
    id: -999, providerChannelIds: [0], images: ['url(assets/images/desert.jpg)'],
    title: 'NO_CONTENT.Title', bodyText: 'LOADING.Description'
  }
};
